
define('text!app/../../views/home.html',[],function () { return '<div class="background">\n\t<% _.each(slides1, function(slide) { %>\n\t\t<div style="background: url(\'/content/slides/<%=slide.IMAGE1 %>\'); background-position: <%=ANCHORKEY[slide.IMAGE1_ANCHOR]%>"></div>\n    <% }) %>\n</div>\n \n<div class="home">\n  <div class="page-content"></div>\n</div>';});

